export const name = '@lifi/widget';
export const version = '1.28.3';
